"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_APP_BASE_TOKEN_DEFAULTS = void 0;
/**
 * Complete `--sl-custom-app-*` base token defaults for the Custom App scope.
 *
 * Single source of truth consumed by every surface that renders Custom App
 * components outside an active ThemeRow:
 *
 *   - `@affine/core` editor surfaces (builder canvas, preview overlay,
 *     wizard live preview) via `custom-app-defaults.css.ts` and
 *     `preview-theme-contract.ts`.
 *   - The standalone custom-app-viewer bundle mirrors these values in its
 *     static `theme.css` — kept in sync by
 *     `custom-app-viewer/src/__tests__/custom-app-layout-contract.spec.ts`.
 *
 * Values match the `normal` spacing density and 16px base font size that
 * `theme-provider.ts` derives for a default ThemeConfig, so a site without
 * a theme row renders identically to one with the untouched default theme.
 */
exports.CUSTOM_APP_BASE_TOKEN_DEFAULTS = {
    '--sl-custom-app-card-gap': '16px',
    '--sl-custom-app-card-padding': '16px',
    '--sl-custom-app-card-radius': '8px',
    '--sl-custom-app-hero-height': '360px',
    '--sl-custom-app-hero-padding': '48px',
    '--sl-custom-app-nav-width': '240px',
    '--sl-custom-app-content-max-width': '1200px',
    '--sl-custom-app-entry-padding': '24px',
    '--sl-custom-app-tag-radius': '6px',
    '--sl-custom-app-tag-padding': '2px 8px',
    '--sl-custom-app-form-field-gap': '12px',
    '--sl-custom-app-form-field-padding': '10px',
    '--sl-custom-app-gap-xxs': '2px',
    '--sl-custom-app-gap-xs': '4px',
    '--sl-custom-app-gap-sm': '8px',
    '--sl-custom-app-gap-md': '16px',
    '--sl-custom-app-gap-lg': '24px',
    '--sl-custom-app-padding-sm': '8px',
    '--sl-custom-app-padding-md': '16px',
    '--sl-custom-app-padding-lg': '24px',
    '--sl-custom-app-padding-xl': '32px',
    '--sl-custom-app-radius-xs': '2px',
    '--sl-custom-app-radius-sm': '4px',
    '--sl-custom-app-radius-md': '8px',
    '--sl-custom-app-radius-pill': '999px',
    '--sl-custom-app-font-size-xs': '12px',
    '--sl-custom-app-font-size-sm': '14px',
    '--sl-custom-app-font-size-md': '16px',
    '--sl-custom-app-font-size-lg': '18px',
    '--sl-custom-app-font-size-xl': '24px',
    '--sl-custom-app-font-size-display': '36px',
    '--sl-custom-app-shadow-sm': '0 2px 8px rgba(10, 10, 10, 0.08)',
    '--sl-custom-app-shadow-md': '0 8px 24px rgba(10, 10, 10, 0.10)',
    '--sl-custom-app-overlay-scrim': 'linear-gradient(to top, rgba(10, 10, 10, 0.55) 0%, rgba(10, 10, 10, 0.15) 60%, transparent 100%)',
    '--sl-custom-app-contrast-text-color': '#ffffff',
    '--sl-custom-app-tag-bg': 'rgba(80, 144, 211, 0.08)',
    '--sl-custom-app-tag-border': 'rgba(80, 144, 211, 0.40)',
    '--sl-custom-app-tag-text': '#3a7bbf',
    '--sl-custom-app-layout-min-height': '200px',
    '--sl-custom-app-form-max-width': '600px',
    '--sl-custom-app-row-cover-max-height': '400px',
    '--sl-custom-app-textarea-min-height': '80px',
    '--sl-custom-app-article-thumbnail-width': '160px',
    '--sl-custom-app-article-thumbnail-height': '100px',
    '--sl-custom-app-article-thumbnail-mobile-height': '180px',
    '--sl-custom-app-filter-min-width': '120px',
    '--sl-custom-app-full-height': '100%',
    '--sl-custom-app-full-width': '100%',
    '--sl-custom-app-zero': '0',
    '--sl-custom-app-markdown-heading-margin-start': '1.5em',
    '--sl-custom-app-markdown-heading-margin-end': '0.5em',
    '--sl-custom-app-markdown-list-padding': '1.5em',
    '--sl-custom-app-markdown-block-margin': '0.75em 0',
    '--sl-custom-app-markdown-tight-margin': '0.25em 0',
    '--sl-custom-app-markdown-section-margin': '1em 0',
    '--sl-custom-app-markdown-divider-margin': '1.5em 0',
};
